// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCQpSignatureServiceRequestGetRecipientViewGetRecipientViewRequest {
    /**
    * @description Program Identifier
    */
    'programId': number;
    /**
    * @description Account Identifier
    */
    'accountId'?: number | null;
    /**
    * @description Envelope Identifier
    */
    'envelopeId': string;
    /**
    * @description Email
    */
    'email': string;
    /**
    * @description Name
    */
    'name': string;
    /**
    * @description Return Url
    */
    'returnUrl': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCQpSignatureServiceRequestGetRecipientViewGetRecipientViewRequest>> = [
        {
            "name":     "programId",
            "baseName": "programId",
            "type":     "number"
        },
        {
            "name":     "accountId",
            "baseName": "accountId",
            "type":     "number"
        },
        {
            "name":     "envelopeId",
            "baseName": "envelopeId",
            "type":     "string"
        },
        {
            "name":     "email",
            "baseName": "email",
            "type":     "string"
        },
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "returnUrl",
            "baseName": "returnUrl",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TCQpSignatureServiceRequestGetRecipientViewGetRecipientViewRequest.attributeTypeMap;
    }
}
